<div class="preferences" *ngIf="ready" [@quickFadeIn]>
  <form [formGroup]="userPreferencesForm" (ngSubmit)="processForm()">
    <p class="title">
      <span class="slds-icon_container slds-icon_container_circle slds-icon-standard-approval">
        <svg class="slds-icon slds-icon_small" aria-hidden="true">
          <use xlink:href="/assets/icons/standard-sprite/svg/symbols.svg#resource_preference"></use>
        </svg>
      </span>
      {{ 'userPreferences.title' | translate }}
    </p>
    <p class="slds-m-top_xx-large slds-m-bottom_xx-large">{{ 'userPreferences.subtitle' | translate }}</p>

    <p class="sub-title slds-m-top_large slds-m-bottom_large">{{ 'userPreferences.preferenceSection' | translate }}</p>
    <div class="slds-grid slds-gutters">
      <div class="slds-col slds-size_1-of-4">
        <ngl-select [label]="'userPreferences.language' | translate">
          <select ngl formControlName="language">
            <option [value]="null">{{ 'createCase.defaultSelectValue' | translate }}</option>
            <option *ngFor="let item of languages" [value]="item.apiName">{{ item.label }}</option>
          </select>
        </ngl-select>
      </div>
    </div>

    <p class="sub-title mt-custom-large slds-m-bottom_large">{{ 'userPreferences.caseEntrySection' | translate }}</p>
    <div class="slds-grid slds-gutters">
      <div class="slds-col slds-size_1-of-4">
        <ngl-select [label]="'userPreferences.country' | translate">
          <select ngl formControlName="inquirerCountry" (change)="reloadBusinessUnits()">
            <option [value]="null">{{ 'createCase.defaultSelectValue' | translate }}</option>
            <option *ngFor="let inquirerCountry of countries" [value]="inquirerCountry.apiName">
              {{ inquirerCountry.label }}
            </option>
          </select>
        </ngl-select>
      </div>
      <div class="slds-col slds-size_1-of-4">
        <ngl-select [label]="'userPreferences.businessUnit' | translate">
          <select ngl formControlName="businessUnit">
            <option [value]="null">{{ 'createCase.defaultSelectValue' | translate }}</option>
            <option *ngFor="let businessUnit of businessUnits" [value]="businessUnit.apiName">
              {{ businessUnit.label }}
            </option>
          </select>
        </ngl-select>
      </div>
    </div>

    <div class="slds-grid slds-gutters slds-m-top_x-large">
      <div class="slds-col slds-size_1-of-4">
        <ngl-select [label]="'userPreferences.shipment' | translate">
          <select ngl formControlName="shipmentIdentifier">
            <option [value]="null">{{ 'createCase.defaultSelectValue' | translate }}</option>
            <option *ngFor="let shipmentIdentifier of shipmentIdentifiers" [value]="shipmentIdentifier.apiName">
              {{ shipmentIdentifier.label }}
            </option>
          </select>
        </ngl-select>
      </div>
    </div>

    <div class="slds-m-top_xx-large">
      <button variant="brand" type="submit" [disabled]="showTopToast" nglButton>
        {{ 'userPreferences.saveBtn' | translate }}
      </button>
    </div>
  </form>
</div>
